import { ModalHeader } from "../../../components/common/Modal/ModalHeader"
import { Modal } from "../../../components/common/Modal/Modal"
import { ModalBody } from "../../../components/common/Modal/ModalBody"
import { Box, Grid, Divider, Typography, ListItemButton, TextField, Accordion, AccordionDetails, AccordionSummary } from "@mui/material"
import { useAssignmentStore } from "../../../hooks/useAssignmentStore"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const DetailModalHistory: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal } = props
    const { selectedHistoryAssignment } = useAssignmentStore();

    console.log('selectedAssignment', selectedHistoryAssignment)
    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick size="sm">
            <ModalHeader
                text={'Detalle de la Cesión'}
                className='positionElements'
                onCancel={closeModal}
            >
            </ModalHeader>
            <ModalBody>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Información General</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Cedente</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.name_assignor}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Cesionario</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.name_assignee}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Tipo</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment?.idowner_assignee ? 'Propietario' : 'Externo'}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Fecha de Creación</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.created_date}</Typography>
                            </ListItemButton>
                            <Divider />

                        </AccordionDetails>


                    </Accordion>

                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Cedente</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>RUT</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.rut_assignor}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Nombre</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.name_assignor}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Correo</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.email_assignor}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Teléfono</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.phone_assignor}</Typography>
                            </ListItemButton>
                            <Divider />

                        </AccordionDetails>
                    </Accordion>

                    <Accordion>

                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Cesionario</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>RUT</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment?.idowner_assignee ? selectedHistoryAssignment?.rut_assignee : selectedHistoryAssignment?.rut_invited_owner}</Typography>
                            </ListItemButton>
                            <Divider />

                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Tipo</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment?.idowner_assignee ? 'Propietario' : 'Externo'}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Nombre</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment?.idowner_assignee ? selectedHistoryAssignment?.name_assignee : selectedHistoryAssignment?.name_invited_owner}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Email</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment?.idowner_assignee ? selectedHistoryAssignment?.email_assignee : selectedHistoryAssignment?.email_invited_owner}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Teléfono</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment?.idowner_assignee ? selectedHistoryAssignment?.phone_assignee : selectedHistoryAssignment?.phone_invited_owner}</Typography>
                            </ListItemButton>
                            <Divider />


                        </AccordionDetails>

                    </Accordion>


                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Departamento</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Cedente</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.name_department}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Cesionario</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.address_department}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Departamento</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.location_url_department}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Departamento</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.num_owner_department}</Typography>
                            </ListItemButton>
                            <Divider />


                        </AccordionDetails>
                    </Accordion>


                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Reserva</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Código</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.code_reservation}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Fecha Inicio</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.arrival_date_reservation}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Fehca Fin</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.exit_date_reservation}</Typography>
                            </ListItemButton>
                            <Divider />
                            <ListItemButton>
                                <Typography sx={{ width: '40%', flexShrink: 0 }}>Fecha de Creación</Typography>
                                <Typography sx={{ color: 'text.secondary' }}>{selectedHistoryAssignment.date_reservation}</Typography>
                            </ListItemButton>
                            <Divider />


                        </AccordionDetails>
                    </Accordion>
                </Box>
            </ModalBody>
        </Modal>
    )
}